export default __webpack_public_path__ + "images/PH.27b6cba.png";